import React, { Component } from 'react';
import axios from 'axios';

import Loader from 'components/Loader';

import { backendUrl, basicAuth } from 'utils/constantsHelper';
import { langCodeTA } from 'utils/currentLanguage';
import { redirectToErrorPage } from 'utils/redirectToErrorPage';

export const withBullitenData = (WrappedComponent) => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        statusCode: null,
        loading: true,
        data: {},
      };
    }

    getData = () => {
      const alias = this.props.match.params.alias;

      axios({
        method: 'get',
        url: backendUrl + langCodeTA + '/' + alias + '?_format=json',
        headers: {
          ...basicAuth,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              data: response.data,
            });
          }
          this.setState({
            loading: false,
          });
        })
        .catch((error) => {
          redirectToErrorPage();
          this.setState({
            loading: false,
          });
        });
    };

    componentDidMount() {
      this.getData();
    }

    render() {
      if (this.state.loading) {
        return <Loader />;
      }

      return (
        <WrappedComponent
          data={this.state.data}
          loading={this.state.loading}
          {...this.props}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/withBullitenData/withBullitenData.js